import { Dot, Flex, FlexProps, Text, TypeColors } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

interface Props extends FlexProps {
  color: TypeColors;
}

const BuildSeriesKey: FunctionComponent<Props> = ({ children, color, ...rest }) => {
  return (
    <Flex {...rest} alignChildrenVertical="middle" direction="horizontal" gap="x2">
      <Flex>
        <Dot backgroundColor={color} size="12px" />
      </Flex>

      <Flex grow>
        <Text>{children}</Text>
      </Flex>
    </Flex>
  );
};

export default BuildSeriesKey;
